// css
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

import { useMediaQuery } from "react-responsive";

// global
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Inicio from "./Components/Inicio";
import StickyFooter from "./Components/parts/StickyFooter";

export const SPEEDSIZE_PREFIX =
  "https://ecdn.speedsize.com/d1928fec-41f1-4078-8fe1-3b4868da9016";

export const regis = `https://www.codere.mx/registro-deportes?clientType=sportsbook`;

const App = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  return (
    <>
      <Header device={isMobile} />
      <Inicio flag={isMobile} />
      {isMobile && <StickyFooter />}
      <Footer device={isMobile} />
    </>
  );
};

export default App;
